import React from 'react';

export function ImgInsta2(){

    return (

        <>
            <img loading = "lazy" className = "noChange" src = "img/beneficioInss.png"/>
        </>
    );
}